var r = /* @__PURE__ */ ((o) => (o.FROM = "from", o.TO = "to", o))(r || {});
export {
  r as DateRangeFilterParam
};
